import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn, MDBBtnGroup } from "mdbreact";
import { LABRESULT } from "./../../../../../../services/redux/slices/commerce/pos/services/deals";
import Swal from "sweetalert2";
import {
  SetTASK,
  SetMODAL,
  SetHEALTHY,
  SetVALIDATOR,
} from "./../../../../../../services/redux/slices/diagnostics/laboratory/validator";

const Footer = ({ setShowHC = () => {} }) => {
  const { token, activePlatform } = useSelector(({ auth }) => auth);
  const { success, task, selected } = useSelector(({ validator }) => validator);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const department = activePlatform?.department;
  useEffect(() => {
    if (success) {
      dispatch(SetHEALTHY(false));
    }
  }, [success, dispatch]);

  const computeHemaDiff = (hasDone) => {
    const { dc = {}, packages } = task;
    const total = Object.values(dc).reduce((total, value) => total + value, 0);

    if (total !== 100 && packages.includes(58)) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Diff Count",
        text: `Your total Diff Count is ${total}.`,
        footer: "<i class='text-info'>Diff Count must always equal to 100</i>",
      });
    }

    handleSave(hasDone);
  };
  const hasDoneChecker = (_id = "") => {
    const diagnostics = Object.values(selected?.diagnostic)
      .flat(Infinity)
      .filter((item) => item)
      .filter((item) => item?._id !== _id);
    return diagnostics.every(({ hasDone = false }) => hasDone);
  };

  const handleSave = (hasDone) => {
    const { form } = task;

    // if laboratory =pathogist
    // if radiologist  and xray = radiologist
    // if radiologist  and ultrasound = sonographer
    // if radiologist  and ecg   = cardiologist

    const data = ["xray", "ultrasound", "miscellaneous"].includes(form)
      ? (() => {
          const { _id, ...rest } = task;
          return {
            ...rest,
            hasDone,
            department,
          };
        })()
      : {
          ...task,
          hasDone,
          department,
        };
    const allDiagHasDone = hasDoneChecker(data?._id) && hasDone;
    const status = allDiagHasDone ? "done" : "onProcess";
    setIsLoading(true);
    dispatch(
      LABRESULT({
        token,
        data,
        status,
      })
    ).then(({ payload }) => {
      const basePayload = payload?.item || payload?.payload;
      dispatch(SetVALIDATOR({ ...basePayload, status }));
      dispatch(SetMODAL(false));
      setIsLoading(false);
    });
  };

  const handleDisablePost = () => {
    const { signatories = [] } = task;
    const [dr = null, head = null] = signatories;
    if (task.form === "2DEcho") return false;
    if (!dr || !head) return true;
    if (task.form === "Ecg") return task.findings ? false : true;
    return task.description && task.impression ? false : true;
  };
  console.log("task", task.form);
  return (
    <div className="text-center mb-1-half border-top pt-2">
      <textarea
        placeholder="Remarks"
        value={task?.remarks}
        onChange={(e) =>
          dispatch(
            SetTASK({
              form: task?.form,
              task: { ...task, remarks: e.target.value },
            })
          )
        }
        className="w-100"
      />

      {/* Button Layout */}
      <div className="d-flex justify-content-between align-items-center my-2">
        {/* Left: Healthy Client Button (if applicable) */}
        {/* <MDBBtn onClick={() => setShowHC(true)} color="success">
          Healthy client
        </MDBBtn> */}

        {/* Right: Save & Post Buttons */}
        <div className="ml-auto">
          <MDBBtnGroup>
            {task.form !== "2DEcho" && (
              <MDBBtn
                disabled={isLoading || handleDisablePost()}
                id="task-post-btn"
                onClick={() => {
                  if (task?.form === "Hematology") return computeHemaDiff(true);
                  handleSave(true);
                }}
                color="success"
              >
                Post
              </MDBBtn>
            )}
            <MDBBtn
              disabled={isLoading}
              onClick={() => {
                if (task?.form === "Hematology") return computeHemaDiff(false);
                handleSave(false);
              }}
              color="info"
            >
              Save
            </MDBBtn>
          </MDBBtnGroup>
        </div>
      </div>
    </div>
  );
};

export default Footer;
